import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
import ModalForm from "../components/modalForm";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const VerticalSources = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "Verticais",
            route: "/verticais"
        },
        {
            text: "Sources Vertical",
            route: "#"
        }
    ];

    let inputs = [
            {
                type: "select",
                name: "id_utm_source",
                label: "UTM Source",
                isRequired: true,
                id: "listUtmSources",
                value: "0",
                options:[   
                            {
                                text: "Selecione a source",
                                value: "0"
                            },
                        ]
            },
    ];

    return (
        <div className="container">
            <ModalForm input={inputs} action="save-vertical-source" elemId="verticalSourceModal" isEdit={false} title="Source Vertical" />

            <div className="defaultContainer">
               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">Sources Vertical
                            <button type="button" className="btn btn-sm btn-add" data-bs-toggle="modal" data-bs-target="#verticalSourceModal">
                                <span className="material-symbols-outlined transition">add_box</span>
                            </button>
                        </h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>
                <br />
                
                <div className="row">
                    <div className="col-12">
                        <table id="dtVerticalsSources" className="dataTables cell-border table table-bordered table-striped" style={{width:"100%"}}>
                            <thead>
                                <tr className="thead-dark">
                                    <th>UTM Source</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>    
                    </div>
                </div> 

            </div>
            <HelmetProvider>
                <Helmet>
                    {/* <script src="../js/checkPermissions.js" type="text/javascript"></script>     */}
                    <script src="../js/datatables/vertical_sources.js" type="text/javascript"></script>
                </Helmet>
            </HelmetProvider> 
        </div>
    );
}

export default VerticalSources;